import React from 'react';

interface DateTimeFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type: 'date' | 'time' | 'datetime-local';
  error?: string;
  required?: boolean;
  helpText?: string;
}

export default function DateTimeField({
  label,
  value,
  onChange,
  type,
  error,
  required = false,
  helpText
}: DateTimeFieldProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2  ${
          error
            ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
            : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
        }`}
      />
      {helpText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helpText}</p>
      )}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}